import { useMemo } from "react";

import {
  Offer,
  PolicyPlan,
  PolicyUsage,
} from "@covertree/new-business-graphql";
import { NewBusinessPolicyState } from "@covertree/new-business-redux";

import { createPersonalisedPlanWithDetails } from "../forms/personalizedPlans";

const plansOrder: PolicyPlan[] = [
  PolicyPlan.Silver,
  PolicyPlan.Gold,
  PolicyPlan.Platinum,
  PolicyPlan.CoverTree,
];

export const usePersonalizedPlanData = (
  policy: NewBusinessPolicyState,
  isBookConversion = false
) => {
  const coveragesFlowData = useMemo(() => {
    const policyUnit = policy.units[0];
    const policyUnitCoverages = policyUnit.unitLevelCoverages;
    const waterDamageCoverage = policyUnitCoverages.waterDamage.value;
    const waterDamageDeductibleCoverage =
      policyUnitCoverages.deductibles.waterDamageDeductible;

    return {
      isVacantFlow: policy.mainUnitType === PolicyUsage.Vacant,
      isSeasonalFlow: policy.mainUnitType === PolicyUsage.Seasonal,
      isTenantFlow: policy.mainUnitType === PolicyUsage.Tenant,
      isRentalFlow: policy.mainUnitType === PolicyUsage.Rental,
      hasWaterDamage: !!waterDamageCoverage,
      hasWaterDamageDeductible: !!waterDamageDeductibleCoverage,
    };
  }, [policy]);
  const { personalizedPlans, shouldDisplayPremisesLiability } = useMemo(() => {
    const offers: Offer[] = policy.offers ?? [];
    const shouldDisplayPremisesLiability =
      policy.units[0].unitLevelCoverages.coverageEPremisesLiability.value !==
      null;

    return {
      shouldDisplayPremisesLiability,
      personalizedPlans: offers
        .toSorted(
          (a, b) => plansOrder.indexOf(a.plan) - plansOrder.indexOf(b.plan)
        )
        .map((offer) =>
          createPersonalisedPlanWithDetails(offer, isBookConversion)
        ),
    };
  }, [policy, isBookConversion]);

  return {
    coveragesFlowData,
    personalizedPlans,
    shouldDisplayPremisesLiability,
  };
};
